import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { COMPETITONS_API } from 'src/apiConfig';

export const ActiveModesContext = createContext();

export const ActiveModesProvider = ({ children }) => {
  const [activeModes, setActiveModes] = useState([]);

  useEffect(() => {
    const fetchActiveModes = async () => {
      try {
        const response = await axios.get(`${COMPETITONS_API}?active=true`);
        setActiveModes(response.data.success || []);
      } catch (error) {
        console.error('Failed to fetch active modes:', error);
      }
    };

    fetchActiveModes();
  }, []);

  return (
    <ActiveModesContext.Provider value={{ activeModes }}>
      {children}
    </ActiveModesContext.Provider>
  );
};
